<script lang="ts" setup>
  import { computed } from 'vue'
  import BaseCounterInput from '@/shared/components/BaseCounterInput/BaseCounterInput.vue'
  import { DEFAULT_DESCRIPTION, DEFAULT_TITLE } from './AmountCounter.constants'

  interface Props {
    modelValue: number
    title: string
    description: string
    maxValue?: number
    minValue?: number
    minDisabled?: boolean
    maxDisabled?: boolean
    dataTest?: string
  }
  interface Emits {
    (e: 'update:modelValue', value: number): void
  }

  const props = withDefaults(defineProps<Props>(), {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    dataTest: 'amount-counter',
  })

  const emit = defineEmits<Emits>()

  const value = computed<number>({
    get() {
      return props.modelValue
    },
    set(newValue: number) {
      emit('update:modelValue', newValue)
    },
  })
</script>

<template>
  <div class="amount-counter" :data-test="dataTest">
    <div class="amount-counter__info">
      <div class="amount-counter__title">{{ title }}</div>
      <div class="amount-counter__desc">{{ description }}</div>
    </div>
    <BaseCounterInput
      v-model="value"
      :max-value="maxValue"
      :min-value="minValue"
      :min-disabled="minDisabled"
      :max-disabled="maxDisabled"
      :data-test="`${dataTest}-input`"
    />
  </div>
</template>

<style scoped lang="scss">
  @import './AmountCounter';
</style>
